module.exports = __webpack_public_path__ + "img/sensores_de_nivel.c5da93e8.jpg";